import { render, staticRenderFns } from "./SlipMain.vue?vue&type=template&id=2cba04c5&scoped=true"
import script from "./SlipMain.vue?vue&type=script&lang=js"
export * from "./SlipMain.vue?vue&type=script&lang=js"
import style0 from "./SlipMain.vue?vue&type=style&index=0&id=2cba04c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba04c5",
  null
  
)

export default component.exports